import { useEffect } from 'react'
import { customerData } from '../../../utilities/CustomerData'

export function RefundShippingOptions({ refundType, step, setStep, setShippingOption }) {
  useEffect(() => {
    window.scrollTo(0,0)

    if(customerData.customerShippoLabels.find(label => label.labelType === refundType)) {
      setStep(step+1)
    }
  }, [])

  return (
    <div className='lg:w-3/4 w-11/12 flex flex-col items-center space-y-6'>
      <p className='text-2xl font-bold text-center'>Shipping Options</p>
      <p className='text-center text-gray-700'>Please select one of the following shipping options for your SETC Packet.</p>
      {refundType === 'Advance Funding' ? (
        <div className='w-full flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-6'>
          <div className='flex-1 border rounded-lg p-4 shadow'>
            <p className='text-lg font-bold'>Print at UPS Store:</p>
            <ul className='list-disc ml-8 space-y-4'>
              <li>
                <p className='font-bold'>Cloud Ready Generated QR Code:</p>
                <ul className='list-disc ml-8 mt-2'>
                  <li>You will be provided a QR code that contains the ready-to-print documents.</li>
                </ul>
              </li>
              <li>
                <p className='font-bold'>Locate UPS Store:</p>
                <ul className='list-disc ml-8 mt-2'>
                  <li>Use the QR code to access a map to the nearest UPS Store based on your zip code.</li>
                  <p className='text-sm text-gray-500 italic'>
                    *Note: This QR Code can be used at any UPS Store location.
                  </p>
                </ul>
              </li>
              <li>
                <p className='font-bold'>Print and Sign Documents at UPS:</p>
                <ul className='list-disc ml-8 mt-2'>
                  <li>Present the QR code at the UPS Store.</li>
                  <li>Request onsite printing of the documents: 1040x, 1040, 7202, 2848, and 8822, Schedule 3.</li>
                  <li>Sign the required documents.</li>
                </ul>
              </li>
              <li>
                <p className='font-bold'>Label and Send:</p>
                <ul className='list-disc ml-8 mt-2'>
                  <li>Use the provided envelope and label at the UPS Store.</li>
                  <li>The UPS Store will send the documents directly to the Roseville Processing Center.</li>
                </ul>
              </li>
            </ul>
            <div className='w-full flex flex-col justify-center mt-8'>
              <button onClick={() => setShippingOption('ReadyCloud')} className='px-6 py-2 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-bold rounded'>Choose Print at UPS Store</button>
            </div>
          </div>
        </div>
      ) : refundType === 'Pre-Paid' ? (
        <div className='w-full flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-6'>
          <div className='flex flex-col flex-1 border rounded-lg p-4 shadow'>
            <p className='text-lg font-bold'>Print at Home:</p>
            <ul className='list-disc ml-8 space-y-2'>
              <li>Print your packet from your printer.</li>
              <li>Follow the Signing Instructions attached to your packet.</li>
              <li>Place all documents in a single envelope.</li>
              <li>Mail your envelope to the IRS.</li>
            </ul>
            <div className='w-full flex flex-col justify-center mt-8'>
              <button onClick={() => setStep(step+1)} className='px-6 py-2 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-bold rounded'>Choose Print at Home</button>
            </div>
          </div>
        </div>
      ) : (
        <div className='w-full flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-6'>
          <div className='flex flex-col flex-1 border rounded-lg p-4 shadow'>
            <p className='text-lg font-bold'>Print at Home:</p>
            <ul className='list-disc ml-8 space-y-2'>
              <li>Print your packet from your printer.</li>
              <li>Follow the Signing Instructions attached to your packet.</li>
              <li>Place all documents in a single envelope.</li>
              <li>Mail your envelope to the IRS.</li>
            </ul>
            <div className='w-full flex flex-col justify-center lg:mt-auto mt-8'>
              <button onClick={() => setStep(step+1)} className='px-6 py-2 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-bold rounded'>Choose Print at Home</button>
            </div>
          </div>
          <div className='flex flex-col flex-1 border rounded-lg p-4 shadow'>
            <p className='text-lg font-bold'>Print at Home w/ Shipping Label:</p>
            <ul className='list-disc ml-8 space-y-2'>
              <li>Generate a Shippo label preconfigured with the addresses.</li>
              <li>Print your packet from your printer.</li>
              <li>Follow the Signing Instructions attached to your packet.</li>
              <li>Place all documents in a single envelope.</li>
              <li>Mail the envelope with the Shippo Label attached.</li>
            </ul>
            <div className='w-full flex flex-col justify-center lg:mt-auto mt-8'>
              <button onClick={() => setShippingOption('Shippo')} className='px-6 py-2 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white font-bold rounded'>Choose Print at Home w/ Shipping Label</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

/**
 *  
 */